module.exports = __webpack_public_path__ + "img/no_team_image.8857758f.png";